// @vendors
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// @assets
import {
  discordLink,
  instagramLink,
  twiterLink,
  xervixAdmonEmail,
  xervixPhoneNumber,
} from "../../../helpers/functionsUtils";

const ContactHero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 px-4 md:px-8">
      <div className="flex flex-col md:flex-row items-center max-w-7xl mx-auto">
        <div className="md:w-2/3 mb-4 md:mb-0">
          <img
            src="/assets/img/landing-page/contact-cellphone.png"
            alt="Contact Information"
            className="w-full max-w-xs mx-auto hidden lg:block"
          />
        </div>
        <div className="md:w-4/5 md:pl-2">
          <h2 className="text-3xl uppercase font-bold mb-4 text-textBrand dark:text-dark-textBrand">
            {t("landingPage.contactHero.title")
            }</h2>
          <h3 className="text-2xl font-bold mb-6">
            {t("landingPage.contactHero.subtitle")}
          </h3>
          <p className="text-cTextSecondary mb-8 dark:text-dark-cText">
            {t("landingPage.contactHero.description")}
          </p>

          <div className="bg-bgBrand text-textOnBrand dark:bg-dark-bgBrand dark:text-dark-textOnBrand p-6 rounded-md">
            <h4 className="text-xl font-bold mb-4">
              {t("landingPage.contactHero.titleBanner")}
            </h4>
            <div className='flex justify-between items-center'>
              <div className="space-y-2">
                <p>{t("landingPage.contactHero.phone")}: {xervixPhoneNumber}</p>
                <p>{t("landingPage.contactHero.email")}: {xervixAdmonEmail}</p>
              </div>
              <div className="flex self-end gap-2">
                <Link
                  target="_blank"
                  to={twiterLink}
                >
                  <img
                    src="/assets/icons/twiter.svg"
                    alt="Twiter logo"
                    className="w-[25px] h-auto"
                  />
                </Link>

                <Link
                  target="_blank"
                  to={instagramLink}
                >
                  <img
                    src="/assets/icons/instagram.svg"
                    alt="Instagram logo"
                    className="w-[25px] h-auto"
                  />
                </Link>

                <Link
                  target="_blank"
                  to={discordLink}
                >
                  <img
                    src="/assets/icons/discord.svg"
                    alt="Discord logo"
                    className="w-[25px] h-auto"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
